import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../services/firebase";
import { COMPETITION_SLUG } from "./constants";
import { Spinner, Input, Alert } from "reactstrap";
import CertificatePrintModal from "./components/CertificatePrintModal";

import compOutono from "../../../assets/images/compOutono.png";
import neoLogo from "../../../assets/images/Neo_Logo_A.svg";

const CompetitionCertificateVerifyPage = () => {
    const [searchCode, setSearchCode] = useState("");
    const [athlete, setAthlete] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searched, setSearched] = useState(false);

    // Modal de Impressão do Certificado
    const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);

    const getParamCode = () => {
        return new URLSearchParams(window.location.search).get("code");
    };

    useEffect(() => {
        const urlCode = getParamCode();
        if (urlCode) {
            setSearchCode(urlCode);
            handleVerifyCode(urlCode);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleVerifyCode = async (codeToVerify) => {
        const cleanCode = (codeToVerify || searchCode).trim().toUpperCase();
        if (!cleanCode) return;

        setLoading(true);
        setError(null);
        setAthlete(null);
        setSearched(true);

        try {
            // Busca na subcoleção "members" da competição Taça Outono
            const membersRef = collection(db, "competitions", COMPETITION_SLUG, "members");
            const q = query(membersRef, where("verificationCode", "==", cleanCode));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                const docSnap = querySnapshot.docs[0];
                const data = docSnap.data();
                
                // Só valida se tiver distância cadastrada e pagamento aprovado/confirmado
                const distance = data.result?.distance || 0;
                const status = data.paymentStatus || "";
                const isPaid = status === "approved" || status === "confirmed";

                if (distance > 0 && isPaid) {
                    setAthlete({
                        id: docSnap.id,
                        ...data
                    });
                } else {
                    setError("Este competidor possui inscrição pendente ou não cadastrou a distância final da prova.");
                }
            } else {
                setError("Chave de validação inválida ou não encontrada. Certifique-se de digitar no formato O26-XXXXXX.");
            }
        } catch (err) {
            console.error("Erro ao validar certificado:", err);
            setError("Ocorreu um erro técnico ao realizar a consulta. Tente novamente mais tarde.");
        } finally {
            setLoading(false);
        }
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        // Atualiza a URL sem recarregar para facilitar o compartilhamento
        const newUrl = `${window.location.pathname}?code=${searchCode.trim().toUpperCase()}`;
        window.history.pushState({ path: newUrl }, '', newUrl);
        handleVerifyCode(searchCode);
    };

    return (
        <div 
            style={{
                minHeight: '100vh',
                backgroundImage: `linear-gradient(135deg, rgba(26, 18, 9, 0.94) 0%, rgba(44, 24, 16, 0.96) 50%, rgba(10, 8, 5, 0.98) 100%), url(${compOutono})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '24px 15px',
                color: '#fff',
                fontFamily: "'Outfit', sans-serif"
            }}
        >
            <div 
                style={{
                    width: '100%',
                    maxWidth: '550px',
                    backgroundColor: 'rgba(255, 253, 249, 0.08)',
                    backdropFilter: 'blur(16px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '16px',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
                    padding: '36px 30px',
                    textAlign: 'center'
                }}
            >
                {/* Logo e Cabeçalho */}
                <div style={{ marginBottom: '28px' }}>
                    <Link to="/">
                        <img src={neoLogo} alt="NEO Logo" style={{ height: '36px', filter: 'brightness(0) invert(1)', marginBottom: '14px' }} />
                    </Link>
                    <h1 style={{ fontSize: '1.4rem', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '2px', color: '#e8d5c0', margin: 0 }}>
                        Auditabilidade de Certificado
                    </h1>
                    <span style={{ fontSize: '0.8rem', color: '#a08b7a', letterSpacing: '1px', textTransform: 'uppercase' }}>
                        Taça Outono de Natação 2026
                    </span>
                </div>

                {/* Formulário de Busca */}
                <form onSubmit={handleSearchSubmit} style={{ marginBottom: '30px' }}>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <Input 
                            type="text"
                            placeholder="Digite a Chave (ex: O26-6TDDI7)"
                            value={searchCode}
                            onChange={(e) => setSearchCode(e.target.value)}
                            style={{
                                backgroundColor: 'rgba(0,0,0,0.2)',
                                border: '1px solid rgba(232, 213, 192, 0.3)',
                                color: '#fff',
                                borderRadius: '8px',
                                padding: '12px 16px',
                                fontSize: '0.95rem',
                                letterSpacing: '0.5px'
                            }}
                            required
                        />
                        <button 
                            type="submit"
                            className="btn"
                            disabled={loading}
                            style={{
                                backgroundColor: '#8b5e3c',
                                color: '#fff',
                                borderRadius: '8px',
                                padding: '0 24px',
                                fontWeight: '700',
                                letterSpacing: '0.5px',
                                transition: 'all 0.2s',
                                border: 'none'
                            }}
                        >
                            {loading ? <Spinner size="sm" /> : "Validar"}
                        </button>
                    </div>
                </form>

                {/* Exibição do Resultado */}
                {loading && (
                    <div style={{ padding: '30px 0' }}>
                        <Spinner style={{ width: '3rem', height: '3rem', color: '#e8d5c0' }} />
                        <p style={{ marginTop: '15px', color: '#a08b7a', fontSize: '0.9rem' }}>Buscando chave no cartório digital...</p>
                    </div>
                )}

                {/* Caso Encontrado: Selo de Autenticidade */}
                {!loading && athlete && (
                    <div className="animate__animated animate__fadeIn">
                        {/* Selo Holográfico Dourado de Sucesso */}
                        <div 
                            style={{
                                border: '2px solid #2d6a4f',
                                backgroundColor: 'rgba(45, 106, 79, 0.12)',
                                borderRadius: '12px',
                                padding: '24px',
                                marginBottom: '24px',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                        >
                            {/* Efeito Brilho Holográfico de Fundo */}
                            <div style={{
                                position: 'absolute',
                                top: '-50%',
                                left: '-50%',
                                width: '200%',
                                height: '200%',
                                background: 'radial-gradient(circle, rgba(212,175,55,0.08) 0%, rgba(0,0,0,0) 70%)',
                                zIndex: 0
                            }} />

                            <div style={{ position: 'relative', zIndex: 1 }}>
                                <div style={{ 
                                    width: '60px', 
                                    height: '60px', 
                                    borderRadius: '50%', 
                                    backgroundColor: '#2d6a4f', 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    margin: '0 auto 14px auto',
                                    boxShadow: '0 4px 10px rgba(0,0,0,0.3)'
                                }}>
                                    <i className="mdi mdi-seal" style={{ fontSize: '32px', color: '#d8f3dc' }} />
                                </div>
                                <h3 style={{ fontSize: '1.15rem', fontWeight: '800', color: '#d8f3dc', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 4px 0' }}>
                                    Certificado Autêntico
                                </h3>
                                <span style={{ fontSize: '0.7rem', color: '#a3b899', letterSpacing: '2px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                                    Registro de Homologação Confirmado
                                </span>
                            </div>
                        </div>

                        {/* Detalhes do Diploma */}
                        <div 
                            style={{
                                backgroundColor: 'rgba(0,0,0,0.15)',
                                borderRadius: '10px',
                                padding: '20px',
                                textAlign: 'left',
                                fontSize: '0.9rem',
                                border: '1px solid rgba(255,255,255,0.05)',
                                marginBottom: '28px'
                            }}
                        >
                            <table style={{ width: '100%', color: '#e8d5c0' }}>
                                <tbody>
                                    <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                                        <td style={{ padding: '8px 0', color: '#a08b7a' }}>Atleta</td>
                                        <td style={{ padding: '8px 0', fontWeight: '700', textAlign: 'right', color: '#fff' }}>
                                            {athlete.fullName || `${athlete.firstName} ${athlete.lastName || ""}`.trim()}
                                        </td>
                                    </tr>
                                    <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                                        <td style={{ padding: '8px 0', color: '#a08b7a' }}>Distância Final</td>
                                        <td style={{ padding: '8px 0', fontWeight: '700', textAlign: 'right', color: '#52b788', fontSize: '1.05rem' }}>
                                            {athlete.result?.distance || athlete.distance} metros 🏊‍♂️
                                        </td>
                                    </tr>
                                    <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                                        <td style={{ padding: '8px 0', color: '#a08b7a' }}>Categoria</td>
                                        <td style={{ padding: '8px 0', fontWeight: '700', textAlign: 'right', color: '#fff' }}>{athlete.category}</td>
                                    </tr>
                                    <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                                        <td style={{ padding: '8px 0', color: '#a08b7a' }}>Clube / Unidade</td>
                                        <td style={{ padding: '8px 0', fontWeight: '700', textAlign: 'right', color: '#fff' }}>{athlete.club || "A2 Aquática"}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: '8px 0', color: '#a08b7a' }}>Técnico / Professor</td>
                                        <td style={{ padding: '8px 0', fontWeight: '700', textAlign: 'right', color: '#fff' }}>{athlete.professor || "Sem Professor"}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Botões de Ação */}
                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                            <button 
                                onClick={() => setIsPrintModalOpen(true)}
                                className="btn"
                                style={{
                                    backgroundColor: '#2d6a4f',
                                    color: '#fff',
                                    borderRadius: '8px',
                                    padding: '12px 24px',
                                    fontWeight: '700',
                                    border: 'none',
                                    flex: 1,
                                    boxShadow: '0 4px 6px rgba(0,0,0,0.15)'
                                }}
                            >
                                <i className="mdi mdi-certificate mr-1" /> Emitir Certificado A4
                            </button>
                        </div>
                    </div>
                )}

                {/* Caso Inválido: Alerta de Erro */}
                {!loading && error && searched && (
                    <Alert color="danger" style={{ backgroundColor: 'rgba(220, 53, 69, 0.15)', border: '1px solid rgba(220, 53, 69, 0.3)', color: '#ffb3c1', borderRadius: '10px', padding: '16px' }}>
                        <i className="mdi mdi-alert-circle mr-2" style={{ fontSize: '18px' }} />
                        {error}
                    </Alert>
                )}

                {/* Link de retorno */}
                <div style={{ marginTop: '30px', borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: '20px' }}>
                    <Link to="/competicao/ranking" style={{ color: '#a08b7a', fontSize: '0.85rem', textDecoration: 'none', transition: 'color 0.2s' }}>
                        <i className="mdi mdi-arrow-left mr-1" /> Voltar para o Ranking Geral
                    </Link>
                </div>
            </div>

            {/* Modal de Impressão do Certificado */}
            {athlete && (
                <CertificatePrintModal 
                    isOpen={isPrintModalOpen}
                    toggle={() => setIsPrintModalOpen(!isPrintModalOpen)}
                    athlete={athlete}
                />
            )}
        </div>
    );
};

export default CompetitionCertificateVerifyPage;
